export const KEY_CLIENT = "6LfWW7AUAAAAANrdpZc_-Sd_My3C3YuxeiWwbcQV";
export const URL_APP = process.env.VUE_APP_URL
